'use client'

import { ReviewMessageParams } from '@/types'
import { useSubmitReviewInteraction } from '@/services/mutations/reviewInteraction'

type SubmitReviewMessageCallbacks = {
  onOptimisticApplied?: () => void
  onRollback?: () => void
}

export const useSubmitReviewMessage = () => {
  const { submitInteraction } = useSubmitReviewInteraction()

  const handleSubmit = async (
    {
      review,
      message,
      mentions = [],
      target,
      mode,
      interactionId,
    }: ReviewMessageParams,
    callbacks?: SubmitReviewMessageCallbacks,
  ) => {
    if (!message.trim()) return

    await submitInteraction(
      {
        review,
        message,
        mentions,
        target,
        mode,
        interactionId,
      },
      callbacks,
    )
  }

  return {
    handleSubmit,
  }
}
